import { useFulfillmentPlanRestrictionsContext } from './context';

/*
The current implementation of the ComponentStates enum (src/enums/component-states.js)
chronicles various flavors of restriction types, all of which can be interpreted as "yes, it is restricted."
Hopefully future work will clean up this enum and its corresponding WebV3Api contract,
but in the meantime we can reasonably return to all consumers
a boolean derived here by simply checking for the presence of ANY componentState value.
*/
export const useHasFulfillmentPlanRestriction = (restrictionName) => {
  const restrictions = useFulfillmentPlanRestrictionsContext();
  const hasComponentRestriction = !!restrictions?.[restrictionName]?.componentState;
  return hasComponentRestriction;
};
